import React, {useEffect} from 'react';
import {Button} from 'antd';
import classNames from 'classnames';

import useTitle from '@/hook/useTitle';
import {useAuthStore} from '@/context/auth';

import styles from './LoginPage.module.less';

export default function LoginPage() {
    useTitle('登录');
    const [, dispatch] = useAuthStore();

    useEffect(() => {
        dispatch('reset');
    }, [dispatch]);

    function onSsoClick() {
        const redirect = `${window.location.origin}/wecomweb/auth/sso/login`;
        window.location.href = redirect;
    }

    return (
        <div className={classNames(styles.container, styles.fixed)}>
            <div className={styles.card}>
                <img src={require('@/asset/login.jpg')} alt="login" height={500} />
                <div className={styles.form}>
                    <div className={styles.submitWrap} style={{width: '100%'}}>
                        <Button size="large" className={styles.submit} onClick={onSsoClick}>
                            使用 BI 帐号登录
                        </Button>
                    </div>

                </div>
            </div>
        </div>
    );
}
